import styled from '@emotion/styled';
import { Button, Drawer, Input, Modal, Table } from 'antd';
import { useEffect, useState } from 'react';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { PackType } from '../../../../redux/userStore/reducer';
import { PRIMARY, YELLOW } from '../../../../shared/colors';
import { deletePack, getPack } from '../../../dashboard/network';
import { Layout } from '../../../shared/Layout';
import { PackForm } from '../components/PackForm';
import { PackUpdateForm } from '../components/PackUpdateForm';

const Container = styled.div`
  height: calc(100vh - 30px);
  display: flex;
  background-color: #1c2025;
  color: white;

  .bread-crum span {
    color: white;
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #acacac;
    color: white;
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: black; /* plus lisible */
    }
  }

  .content {
    padding: 50px;
    width: 100%;
    background-color: #1c2025;
    color: white;
  }
`;

export const PackPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showDrawer1, setShowDrawer1] = useState(false);
  const [pack, setPack] = useState<PackType[]>([]);
  const [filterPack, setFilterPack] = useState<PackType[]>([]);
  const [selectedPack, setSelectedPack] = useState<PackType>({
    id: '0',
    nom: 'OK',
    amount: 0,
    duree_an: 0,
    created_at: 'string',
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const fetchData = () => {
    getPack().then(({ data }) => {
      setPack(data);
      setFilterPack(data);
      setIsLoading(false);
    });
  };
  useEffect(() => {
    fetchData();
  }, []);

  const suppPack = () => {
    setIsLoading(true);
    if (selectedPack) {
      deletePack(selectedPack.id).then(() => {
        setIsLoading(false);
        setShowDeleteModal(false);
        fetchData();
      });
    }
  };
  return (
    <Layout>
      <Container>
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <div style={{ marginTop: 0 }}>
            <h2 style={{ color: 'white' }}>Liste des Packs</h2>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 5,
              }}
            >
              <Input
                placeholder='Search...'
                style={{ width: 250 }}
                onChange={(e) => {
                  setFilterPack(
                    pack.filter((p) =>
                      p.nom
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase()),
                    ),
                  );
                }}
              />

              <Button
                icon={<FaPlus style={{ marginBottom: -2, marginRight: 5 }} />}
                className='butt'
                style={{ borderRadius: 5 }}
                onClick={() => setShowDrawer(true)}
              >
                Nouveau pack
              </Button>
            </div>

            <Table
              columns={COLUMNS}
              dataSource={filterPack}
              rowClassName={(row, index) =>
                index % 2 === 0 ? 'even-row' : 'odd-row'
              }
              size='small'
              loading={isLoading}
              style={{ zoom: 0.9 }}
              pagination={false}
              onRow={(row, rowIndex) => {
                return {
                  onClick: (event) => {
                    setSelectedPack(row);
                    console.log(selectedPack);
                    setShowDrawer1(true);
                  }, // click row
                  onDoubleClick: (event) => {}, // double click row
                  onContextMenu: (event) => {}, // right button click row
                  onMouseEnter: (event) => {}, // mouse enter row
                  onMouseLeave: (event) => {}, // mouse leave row
                };
              }}
            />
          </div>
        </div>
        <Drawer
          title='Ajouter un pack'
          placement='right'
          width={400}
          onClose={() => setShowDrawer(false)}
          open={showDrawer}
          closeIcon={<MdClose size={20} />}
        >
          <PackForm
            setShowDrawer={setShowDrawer}
            getNewPack={(part) => {
              setPack([...pack, part]);
              setFilterPack([...filterPack, part]);
            }}
          />
        </Drawer>
        <Drawer
          title='Modifier un pack'
          placement='right'
          width={400}
          onClose={() => setShowDrawer1(false)}
          open={showDrawer1}
          closeIcon={<MdClose size={20} />}
        >
          <PackUpdateForm
            setShowDrawer={setShowDrawer1}
            setthepack={selectedPack}
            getNewPack={(pack) => {
              setPack(pack);
              setFilterPack(pack);
            }}
          />
          <Button
            icon={<FaTrash style={{ marginBottom: -2, marginRight: 5 }} />}
            className='butt'
            loading={isLoading}
            style={{ borderRadius: 5, backgroundColor: PRIMARY }}
            onClick={() => {
              setShowDeleteModal(true);
              setShowDrawer1(false);
            }}
          >
            Supprimer
          </Button>
        </Drawer>
        <Modal
          open={showDeleteModal}
          title='Supprimer le pack'
          onCancel={() => setShowDeleteModal(false)}
          footer={[
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                danger
                onClick={() => setShowDeleteModal(false)}
                style={{ border: '2px solid red', borderRadius: 20 }}
              >
                Non
              </Button>
              <Button
                className='butt'
                loading={isLoading}
                style={{ borderRadius: 20 }}
                onClick={suppPack}
              >
                Oui
              </Button>
            </div>,
          ]}
        >
          <p>Voulez-vous supprimer ce pack ?</p>
        </Modal>
        ;
      </Container>
    </Layout>
  );
};

const COLUMNS = [
  {
    title: 'NOM DU PACK',
    render: (cell: any, row: PackType) => row.nom,
    sorter: (a: PackType, b: PackType) => a.nom.localeCompare(b.nom),
  },
  {
    title: 'MONTANT',
    render: (cell: any, row: PackType) => row.amount,
  },
  {
    title: 'DUREE (ANNEE)',
    render: (cell: any, row: PackType) => row.duree_an,
  },
];
